import React from 'react';
import {
  setVulnerabilityDetailTab
} from 'store/Manage/actions';
import { selectVulnDetailSelectedTabContext, selectVulnDetail } from 'store/Manage/selectors';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import useTabsShortcuts from 'Hooks/useTabsShortcuts';
import TABS from './tabs';
import { TabSelectorWrapper, TabButton } from './styled';

// Community's backend has no route to list comments for a single vulnerability (Comment
// is a plain ReadWriteWorkspacedView with no /vulnerability/<id> sub-route and no
// filterset_class), so the whole tab -- new in this migration -- can never load anything.
// Hide it here rather than relying on FEATURE_COMMENTS, which is a false positive: that
// permission is allowed in community but doesn't mean this specific backend capability
// exists.
const enabledTabs = TABS.filter((tab) => tab.id !== 'comment');

const Tabs = ({ scope }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const selectedTab = useSelector(selectVulnDetailSelectedTabContext);

  const getLabel = (tab) => intl.formatMessage({ id: tab.intlId });
  const isActive = (tab) => tab.id === selectedTab.id;
  const vuln = useSelector(selectVulnDetail);

  useTabsShortcuts({
    tabs: enabledTabs,
    activeId: selectedTab.id,
    onChange: (id) => dispatch(setVulnerabilityDetailTab(id)),
    scope
  });

  if (!vuln._id) return null;
  return (
    <TabSelectorWrapper>
      { enabledTabs.map((tab) => (
        <TabButton
          active={ isActive(tab) }
          key={ tab.id }
          onClick={ () => dispatch(setVulnerabilityDetailTab(tab.id)) }
          children={ getLabel(tab) }
        />
      ))}
    </TabSelectorWrapper>
  );
};

export default Tabs;
